import {generateRequest} from 'fallco-frontend-framework/src/js/classes/HttpManager/api_utilities.js';

const END_POINT = 'questionari';

const getChecklist = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "get_checklist" , data: params}, callback);
const getRisposte = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "get_all_risposte" , data: params}, callback);
const sendQuestionario = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "send_questionario" , data: params}, callback);
const getAllQuestionari = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "get_all_questionari" , data: params}, callback);
const createModello = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "create_modello" , data: params}, callback);
const getModelli = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "get_modelli" , data: params}, callback);
const deleteModello = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "delete_modello" , data: params}, callback);
const updateModello = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "update_modello" , data: params}, callback);

const apiEndpoint = {
  getChecklist,
  getRisposte,
  getAllQuestionari,
  sendQuestionario,
  createModello,
  getModelli,
  deleteModello,
  updateModello
}

export default apiEndpoint;